import styled from 'styled-components';
import media from '../../../constants/media';

export const ContentContainer = styled.div`
	${media.desktopSmall`
		padding-right: 64px;
		padding-left: 64px;
	`}

	${media.desktopLarge`
		padding-right: 120px;
		padding-left: 120px;
	`}
`;

export const ContentContainerCard = styled(ContentContainer)`
	${media.mobileAndTabletOnly`
		padding-right: 16px;
		padding-left: 16px;
	`}
`;
